import styled from 'styled-components';

import ColorPalette from 'Common/constants/ColorPalette';

export const Divider = styled.div`
  margin: 20px 0;
  border: 1px solid ${ColorPalette.white9};
`;
